import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { useState } from 'react';
import { EPSG_INdexData } from '../../common/EPSGIndexUtils';

interface InfoProps {
    infoData: EPSG_INdexData | null;
}

const InfoDetails = ({ infoData }: InfoProps) => {
    const [showFullText, setShowFullText] = useState(false);

    const handleToggleText = () => {
        setShowFullText(!showFullText);
    };
    const renderAreaContent = (data: any) => {
        const areaText = data;
        if (!areaText) return null;

        if (areaText.length > 50 && !showFullText) {
            return (

                <span className="info_unit_row">
                    {areaText.slice(0, 50)}{' '}
                    <Tooltip placement="leftTop" title={<div style={{ maxWidth: '300px', maxHeight: '200px', overflowY: 'auto' }}>{areaText}</div>}
                        overlayStyle={{ maxWidth: '300px', maxHeight: '200px' }}>
                        <InfoCircleOutlined style={{ cursor: 'pointer', width: "16px", height: "16px", marginLeft: "10px" }} />
                    </Tooltip>
                </span>

            );
        } else {
            return (

                <span className="info_unit_row">
                    {areaText}{' '}
                    {areaText.length > 50 && (
                        <Tooltip placement="leftTop" title={<div style={{ maxWidth: '300px', maxHeight: '200px', overflowY: 'auto' }}>{areaText}</div>}
                            overlayStyle={{ maxWidth: '300px', maxHeight: '200px' }}>
                            <InfoCircleOutlined onClick={handleToggleText} style={{ cursor: 'pointer', width: "16px", height: "16px", marginLeft: "10px" }} />
                        </Tooltip>)}
                </span>

            );
        }
    };


    return (
        <div>
            <div className="info_row"><span className="info_label">Name:</span> {infoData?.name}</div>
            <div className="info_row"><span className="info_label">Code:</span> {infoData?.code}</div>
            <div className="info_row"><span className="info_label info_unit_row">Area:</span> {renderAreaContent(infoData?.area)}</div>
            <div className="info_row"><span className="info_label">Kind:</span> {infoData?.kind}</div>
            <div className="info_row"><span className="info_label">Proj4:</span> {infoData?.proj4}</div>
            <div className="info_row"><span className="info_label">Unit:</span> {infoData?.unit}</div>
            <div className="info_row info_unit_row"><span className="info_label">WKT:</span>
                <Tooltip placement="topLeft" title={<div style={{ maxWidth: '300px', maxHeight: '200px', overflowY: 'auto' }}>{infoData?.wkt}</div>}
                    overlayStyle={{ maxWidth: '300px', maxHeight: '200px' }}>
                    <InfoCircleOutlined color="#ffffff" />
                </Tooltip>
            </div>
        </div>
    );
}

export default InfoDetails;
